<script>
import { map } from 'lodash'

export default {
    name: 'TabbedView',
    data() {
        return {
            activeTabIndex: 0,
        }
    },
    methods: {
        switchTab: function(i) {
            this.activeTabIndex = i
        },
    },
    render(createElement, context) {
        const tabLabels = map(this.$slots.default, s => s.key)
        const activeSlot = this.$slots.default[this.activeTabIndex]

        return createElement('div', { class: ['asd-tab-view'] }, [
            createElement(
                'div',
                { class: ['asd-tabs'] },
                map(tabLabels, (l, i) => createElement(
                    'div',
                    { class: { 'active': this.activeTabIndex === i }, domProps: { innerHTML: l }, on: { click: () => this.switchTab(i) } }
                ))
            ),
            activeSlot,
        ])
    },
}
</script>

<style lang="scss" scoped>
.asd-tab-view {
    .asd-tabs {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid var(--color-primary);
        & > * {
            white-space: nowrap;
            padding: 3px 10px;
            margin-right: 5px;
            border-top-right-radius: 3px;
            border-top-left-radius: 3px;
            border-top: 1px solid;
            border-left: 1px solid;
            border-right: 1px solid;
            background-color: whitesmoke;
            border-color: lightgray;
            cursor: pointer;
        }
        & > *.active {
            border-color: var(--color-input-border);
            background-color: white;
            border-bottom: 1px solid white;
            transform: translateY(1px);
            z-index: 10;
        }
    }
}
</style>
